<template>
    <v-container>
        <form ref="form_file" v-if="!readonly">
            <v-row dense>
                <v-col cols="12">
                    <v-file-input
                        style="width: 100%"
                        name="archivo"
                        clearable
                        ref="inputfile"
                        multiple
                        label="Adjuntar archivos"
                        v-model="file"
                    ></v-file-input>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        label="Buscar"
                        v-model="search"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    class="flex"
                    style="justify-content: space-between"
                >
                    <v-btn
                        :color="grabando ? 'success' : 'primary'"
                        class="white--text"
                        @mousedown="audio"
                        @touchstart="audio"
                        @touchend="audio_stop"
                        @mouseup="audio_stop"
                        >{{ grabando ? "Grabando" : "Grabar audio" }}</v-btn
                    >
                    <v-btn
                        v-if="transferir && selected.length > 0"
                        class="white--text"
                        :color="'success'"
                        @click="TransferirArchivos()"
                        >Asociar a presupuesto</v-btn
                    >
                    <v-btn
                        v-if="selected.length > 0"
                        class="white--text"
                        :color="'success'"
                        @click="DescargarArchivos()"
                        >Descargar archivos</v-btn
                    >
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    v-for="archivo in nombres_archivos"
                    class="flex"
                    v-bind:key="archivo.id"
                >
                    <img
                        v-if="archivo.type == 'image'"
                        class="preview-image-lg"
                        :src="`data:image/jpeg;base64,${archivo.data}`"
                    />
                    <svg
                        v-else
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-3"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                        />
                    </svg>

                    <v-text-field
                        v-model="archivo.nombre"
                        :suffix="`.${archivo.extension}`"
                    ></v-text-field>
                </v-col>
            </v-row>
        </form>
        <v-row dense>
            <v-col cols="12">
                <v-data-table
                    :show-select="true"
                    v-model="selected"
                    dense
                    hide-default-footer
                    disable-pagination
                    :headers="readonly ? headers_readonly : headers"
                    :items="items"
                    item-key="id"
                    :search="search"
                    class="elevation-4"
                    :item-class="
                        () => {
                            return 'pointer';
                        }
                    "
                    @click:row="handleClick"
                >
                    <template v-slot:item.nombre_archivo="{ item }">
                        <a target="_blank" :href="item.url">{{
                            item.nombre
                        }}</a>
                    </template>
                    <template v-slot:item.preview="{ item }">
                        <img
                            v-if="isImageFileName(item.nombre)"
                            class="preview-image-md"
                            :src="item.url"
                        />
                        <svg
                            v-else
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-2"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                            />
                        </svg>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div style="display: flex; align-items: center">
                            <audio
                                :src="item.url"
                                controls
                                v-if="isAudioExtension(item.nombre)"
                                style="margin-right: 1rem"
                            ></audio>
                            <v-icon
                                @click.stop="$emit('delete_archivo', item)"
                                small
                                class="mr-2"
                                color="red"
                            >
                                mdi-trash-can
                            </v-icon>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row v-if="!readonly">
            <v-btn @click="subirArchivo" color="success" class="white--text"
                >Agregar</v-btn
            >
        </v-row>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar audio
                </v-card-title>
                <v-card-text style="text-align: center"
                    ><v-row>
                        <v-col cols="12"> </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="Nombre Archivo"
                                v-model="nombre_archivo"
                            ></v-text-field>
                        </v-col> </v-row
                ></v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="SaveAudio()"
                        >Guardar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <VisorImagenes
            :start_index="visor_index"
            :imagenes="imagenes_visor"
            v-model="visor_dialog"
        ></VisorImagenes>
    </v-container>
</template>
<style>
.preview-image-lg {
    object-fit: contain;
    height: 3rem;
    width: 6rem;
}
.preview-image-md {
    object-fit: contain;
    height: 2rem;
    width: 4rem;
}
</style>
<script>
import VisorImagenes from "./VisorImagenes.vue";
export default {
    components: {
        VisorImagenes,
    },
    props: ["items", "readonly", "extra_headers", "transferir"],
    data() {
        return {
            selected: [],
            visor_dialog: false,
            visor_index: 0,
            dialog: false,
            audio_file: null,
            nombre_archivo: "",
            nombres_archivos: [],
            mediaRecorder: null,
            grabando: false,
            file: null,
            search: "",
            headers_prev: [
                {
                    text: "Archivo",
                    align: "left",
                    value: "nombre_archivo",
                },
                {
                    text: "Vista previa",
                    align: "left",
                    value: "preview",
                },
            ],
            headers_next: [
                {
                    text: "",
                    align: "",
                    value: "action",
                },
            ],
            headers_readonly: [
                {
                    text: "Archivo",
                    align: "left",
                    value: "nombre_archivo",
                },
            ],
        };
    },
    watch: {
        selected: function (val) {
            console.log(val);
        },
        file: async function (file) {
            console.log(file);
            this.nombres_archivos = [];

            if (file != null && (file?.length ?? 0) > 0) {
                const files = document.getElementsByName("archivo")[0].files;
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const type = file.type.startsWith("image/")
                        ? "image"
                        : "document";
                    let data = null;
                    if (type == "image") {
                        data = await this.compressAndConvertToBase64(file, 1);
                    } else {
                        data = await this.prFileToBase64(file);
                    }

                    const nombre = file.name.split(".");

                    this.nombres_archivos.push({
                        data: data,
                        nombre: nombre[0],
                        extension: nombre[1],
                        type: type,
                    });
                }
            }
            console.log(this.nombres_archivos);
        },
        items(n) {
            this.$refs.inputfile.internalValue = [];
        },
    },
    computed: {
        headers: function () {
            let result = [];
            result = result.concat(this.headers_prev);
            if (this.extra_headers != null) {
                result = result.concat(this.extra_headers);
            }
            result = result.concat(this.headers_next);
            return result;
        },
        imagenes_visor: function () {
            return this.items.filter((item) => {
                return this.isImageFileName(item.nombre_archivo);
            });
        },
    },
    created() {
        const me = this;
        // Request permission to access the microphone
    },
    methods: {
        downloadFile(url) {
            const link = document.createElement("a");
            link.href = url;
            link.download = url.split("/").pop(); // Optional: Set a default file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        DescargarArchivos() {
            this.selected.forEach((archivo) => {
                this.downloadFile(archivo.url);
            });
        },
        TransferirArchivos() {
            let archivos_id = [];
            this.selected.forEach((archivo) => {
                archivos_id.push(archivo.id);
            });
            this.$emit("TransferirArchivos", archivos_id);
        },
        handleClick(item) {
            if (this.isImageFileName(item.nombre_archivo)) {
                const index = this.imagenes_visor.indexOf(item);
                this.visor_index = index;
                this.visor_dialog = true;
            } else {
                window.open(item.url, "_blank");
            }
        },
        isImageFileName(fileName) {
            // List of common image file extensions
            const imageExtensions = [
                ".jpg",
                ".jpeg",
                ".png",
                ".gif",
                ".bmp",
                ".webp",
                ".svg",
                ".ico",
            ];

            // Get the file extension from the given fileName
            const fileExtension = fileName
                .substring(fileName.lastIndexOf("."))
                .toLowerCase();

            // Check if the file extension is in the list of image extensions
            return imageExtensions.includes(fileExtension);
        },
        SaveAudio() {
            this.$emit("subir_file_64", {
                data: this.audio_file,
                nombre: this.nombre_archivo,
                extension: "opus",
            });
        },
        compressAndConvertToBase64(file, compressionQuality) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = function () {
                    const img = new Image();
                    img.src = reader.result;

                    img.onload = function () {
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");

                        // Calculate the new dimensions to scale the image
                        const maxWidth = 1080; // Specify your desired maximum width
                        const maxHeight = 1920; // Specify your desired maximum height
                        let newWidth = img.width;
                        let newHeight = img.height;
                        if (newWidth > maxWidth) {
                            newHeight *= maxWidth / newWidth;
                            newWidth = maxWidth;
                        }
                        if (newHeight > maxHeight) {
                            newWidth *= maxHeight / newHeight;
                            newHeight = maxHeight;
                        }

                        // Set the canvas dimensions
                        canvas.width = newWidth;
                        canvas.height = newHeight;

                        // Draw the image onto the canvas
                        ctx.drawImage(img, 0, 0, newWidth, newHeight);

                        // Compress the image as JPEG with the specified quality
                        const compressedDataUrl = canvas.toDataURL(
                            "image/jpeg",
                            compressionQuality
                        );

                        // Convert the compressed image to base64
                        const base64Image = compressedDataUrl.split(",")[1];

                        // Resolve the promise with the base64 image
                        resolve(base64Image);
                    };

                    img.onerror = function () {
                        reject(new Error("Error al leer la imagen."));
                    };
                };

                reader.onerror = function () {
                    reject(new Error("Error al leer el archivo."));
                };

                if (file) {
                    reader.readAsDataURL(file);
                } else {
                    reject(new Error("No file found in the FormData object."));
                }
            });
        },
        audio(event) {
            const me = this;
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then(function (stream) {
                    // Create an instance of MediaRecorder to record the audio stream
                    me.mediaRecorder = new MediaRecorder(stream, {
                        mimeType: "audio/webm;codecs=opus",
                    });

                    // Create an array to store the recorded audio chunks
                    const chunks = [];

                    // Start recording when the media recorder is ready
                    me.mediaRecorder.addEventListener("start", function () {
                        //console.log("Recording started...");
                    });

                    // Collect the audio data chunks as they become available
                    me.mediaRecorder.addEventListener(
                        "dataavailable",
                        function (event) {
                            chunks.push(event.data);
                        }
                    );

                    // Stop recording and process the recorded audio
                    me.mediaRecorder.addEventListener(
                        "stop",
                        async function () {
                            // Convert the audio chunks into a single Blob
                            const audioBlob = new Blob(chunks, {
                                type: "audio/opus",
                            });

                            //console.log(audioBlob);
                            // Read the audio Blob as a Data URL
                            const reader = new FileReader();
                            reader.onloadend = function () {
                                // Obtain the Base64-encoded audio data
                                //const base64Data = reader.result.split(",")[1];
                                me.audio_file = reader.result;
                                console.log(me.audio_file);
                                me.dialog = true;
                                /*me.$emit(
                                    "subir_file_64",

                                    base64Data,
                                    "audio_recording",
                                    "opus",
                                    () => {}
                                );*/
                                //console.log("Base64 audio:", base64Data);
                            };
                            reader.readAsDataURL(audioBlob);
                            stream
                                .getTracks() // get all tracks from the MediaStream
                                .forEach((track) => track.stop()); // stop each of them
                        }
                    );

                    // Start recording for a duration of 10 seconds
                    me.mediaRecorder.start();
                    me.grabando = true;

                    event.preventDefault();
                })
                .catch(function (error) {
                    console.error("Error al acceder al micrófono:", error);
                });
        },
        // Function to encode audio to MP3
        encodeAudioToMP3(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    const samples = new Int8Array(reader.result);
                    const buffer = [];
                    const mp3encoder = new lamejs.Mp3Encoder(1, 44100, 128); // Mono, 44.1khz, 128kbps

                    resolve(
                        new Blob(mp3encoder.encodeBuffer(samples), {
                            type: "audio/mp3",
                        })
                    );
                };

                reader.onerror = reject;
                reader.readAsArrayBuffer(blob);
            });
        },

        audio_stop(event) {
            this.mediaRecorder.stop();
            this.grabando = false;

            event.preventDefault();
        },
        isAudioExtension(file) {
            const audioExtensions = [
                "mp3",
                "wav",
                "ogg",
                "aac",
                "m4a",
                "webm",
                "opus",
            ];
            const extension = file.split(".")[`1`];
            return audioExtensions.includes(extension?.toLowerCase());
        },
        subirArchivo() {
            const me = this;
            this.nombres_archivos.forEach((element) => {
                me.$emit(
                    "subir_file_64",

                    element
                );
            });
        },
        prFileToBase64(file) {
            return new Promise((resolve, reject) => {
                this.fileToBase64(file, (base64string) => {
                    resolve(base64string);
                });
            });
        },
        fileToBase64(file, callback) {
            const reader = new FileReader();
            reader.onload = function (event) {
                const base64String = event.target.result.split(",")[1];
                callback(base64String);
            };

            reader.readAsDataURL(file);
        },
        handleImageFile(file) {
            const compressionQuality = 1; // Specify your desired compression quality between 0 and 1
            const me = this;
            this.compressAndConvertToBase64(file, compressionQuality)
                .then((base64Image) => {
                    //console.log(base64Image);
                    const fileName = file.name;

                    // Remove the extension from the file name
                    const fileNameWithoutExtension = fileName.substring(
                        0,
                        fileName.lastIndexOf(".")
                    );

                    me.$emit(
                        "subir_file_64",

                        {
                            data: base64Image,
                            nombre: fileNameWithoutExtension,
                            extension: "png",
                        }
                    );

                    // Do something with the base64 image
                })
                .catch((error) => {
                    console.error("Un error ha ocurrido:", error);
                });
        },

        addFiles(file_list) {
            if (!file_list.length) {
                return;
            }
            this.$emit("add_files", file_list);
        },
    },
};
</script>
